import React from "react";
import { FormControl, Input, Select, Textarea, Link, Button,  Container, Stack, Flex } from "@airbus/components-react";
import { Spinner } from "@airbus/components-react";
import EventLocationCreateForm from "./EventLocationCreateForm";
import EventLocationUpdateForm from "./EventLocationUpdateForm";
import eventBus from "../eventBus/EventBus";
import WPCalendarEvent from "../models/WPCalendarEvent";
import GlobalWPUser from "../models/WPUser";

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.module.css";
import "../css/DatePicker.css";
import fr from "date-fns/locale/fr";

import '../css/Forms.css';

registerLocale("fr", fr);




class EventEditForm extends React.Component {

    constructor(props){
        super(props);

        this.WPCalendarEvent = new WPCalendarEvent();

        let description = props.description.replace(/(<([^>]+)>)/gi, "");
        description = this.decodeHtmlCharCodes(description);

        //debugger;

        //States;
        this.state={
            form:{
                id: props.id,
                title: props.title,                   //Form handler
                start_date: new Date(props.start_date),
                end_date: new Date(props.end_date),
                date: new Date(props.date),
                description: description,
                allDay: props.allDay ==="Oui"?"true":"false",
                venue: props.venue,
            },
            venues:     [],                     //Venues List 
            selectedVenue: {},                  //venue selected
            selectedVenueID: null,              //Venue id selected
            flag_eventCreateLocation: false,    //Display modal box Event create location
            flag_eventEditLocation: false,      //Display modal box Event update location
            flag_loadingLocation: false,        //Loading in progress location Flag
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height

        }

        //Notifications properties
        this.setNotification=this.props.notificationHandler;  //call parent notification handler
    }

    /**
     * ON COMPONENT LOADED
     */

    componentDidMount=async()=>{

        await this.getVenues();
        let venue = this.WPCalendarEvent.getCalendarVenuByID(parseInt(this.state.form.venue.id));
        
        this.setState({selectedVenue:venue});
        this.setState({selectedVenueID:venue.id});


        //Listener Close Location Create ModalBox
        eventBus.on ("event_modal_location_close", (data) => {          
            
            this.setState({flag_eventCreateLocation: false});
            this.setState({flag_eventEditLocation: false});
            

            //Update Location Information display
            if(data['event_location_update'] === true){
                
                this.updateStateSelectedLocation(parseInt(this.state.selectedVenueID));
                
                
            }

            if(data['event_location_reload'] === true){
                
                this.getVenues(); //New location has been created -> reload list!
            }


        });

        

    }

    componentDidUpdate = () => {
      
        window.addEventListener("resize", this.handleResize);
    }

    /*Handle screen size*/
    handleResize = (e) => {
      
        //debugger;
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
    };

    /*Called once location has been updated by the user*/
    updateStateSelectedLocation = async (id) => {
        this.setState({flag_loadingLocation: true}); //fire loading dots while awaiting
        let venue = await this.WPCalendarEvent.getCalendarVenueByIDForce(id);
        this.setState({flag_loadingLocation: false});
        this.setState({selectedVenue:venue});

    }

    /**
     * RENDERING
     */

    render(){
        return(
            <div>
                               
                
                {/* EVENT LOCATION CREATE MODAL BOX */}
                {this.state.flag_eventCreateLocation ?
                    <EventLocationCreateForm/>
                :null}

                {/* EVENT LOCATION EDIT MODAL BOX */}
                {this.state.flag_eventEditLocation ?
                    <EventLocationUpdateForm    id={this.state.selectedVenue.id}
                                                venue = {this.state.selectedVenue.venue}
                                                address = {this.state.selectedVenue.address}
                                                zip = {this.state.selectedVenue.zip}
                                                city = {this.state.selectedVenue.city}


                    />
                
                :null}


                {/*TITRE*/}
                <Container className="container-left" until="xl" style={{paddingLeft:"0px"}}>
                    <Flex wrap={true} direction="row" >
                    
                    <FormControl
                        className="controlForm"
                        error={!this.titleValid()}
                        errorText="Obligatoire"
                        label="Titre"
                        placeholder="Titre"
                        required
                        style={{height:100}}
                    >
                        <Input value={this.state.form.title} onChange={this.onChangeTitle} />
                    </FormControl>
                    
                    {/*START DATE*/}
                    <FormControl
                        className="controlForm"
                        label="Début événement"
                        style={{height:100}}>
                            
                        <DatePicker
                            locale="fr"
                            selected={this.state.form.start_date}
                            onChange={(date) => this.onChangeStartDate(date)}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy hh:mm aa"
                            isClearable={false}
                                        
                        />
                    </FormControl>
                    
                    
                    
                    {/*END DATE*/}
                    <FormControl
                        className="controlForm"
                        label="Fin événement"
                        style={{height:100}}>
                            
                        <DatePicker
                            locale="fr"
                            selected={this.state.form.end_date}
                            onChange={(date) => this.onChangeEndDate(date)}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy hh:mm aa"
                            isClearable={false}
                                        
                        />
                    </FormControl>

                    {/*DATE PUBLISH*/}
                    <FormControl
                        className="controlForm"
                        label="Date Publication"
                        style={{height:100}}>
                            
                        <DatePicker
                            locale="fr"
                            selected={this.state.form.date}
                            onChange={(date) => this.onChangeDate(date)}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy hh:mm aa"
                            isClearable={false}
                                        
                        />
                    </FormControl>

                    {/*ALL DAY EVENT*/}
                    <FormControl
                        className="controlForm"
                        error={!this.allDayValid()}
                        errorText="Obligatoire"
                        label="Toute la journée"
                        placeholder="Sélectionner"
                        style={{height:100}}
                    >
                        <Select value={this.state.form.allDay} style={{width:'250px'}} placeholder="" onChange={this.onChangeAllDay} >
                            <option value={"false"}>Non</option>
                            <option value={"true"}>Oui</option>
                        </Select>
                    </FormControl>
                    </Flex>
                </Container>
                
                <Container className="container-left" until="xl" style={{paddingLeft:"0px"}}>
                    <Flex wrap={true} direction="row" >
                    
                    {/*DESCRIPTION*/}

                    <Container until="sm" className="container-left" style={{paddingLeft:"0px", marginRight:"unset"}}>
                        <FormControl
                            className="FullWidthcontrolForm"
                            error={!this.descriptionValid()}
                            errorText="Obligatoire"
                            label="Description"
                            placeholder="Description"
                        >
                            <Textarea value={this.state.form.description} onChange={this.onChangeDescription} />
                        </FormControl>
                    </Container>
                    
                    {/*CREATE LOCATION*/}
                    <Container until="xs" className="container-left" style={{paddingLeft:"30px", marginRight:"unset"}}>
                    <Stack className="flex-gap">
                        <FormControl
                            className="select-controlForm"
                            label="Lieu"
                            placeholder="Lieu"
                        >
                            <Select value={this.state.selectedVenueID} placeholder="Sélectionner Lieu" onChange={this.onChangeLocation} >
                                    <option key='null' value=''></option>
                                    {this.state.venues.map(item => <option key={item.id} value={item.id} >{item.venue}</option> )}
                            </Select>
                        </FormControl>

                        <FormControl
                            className="select-controlForm"
                            >
                            <Button  
                                    onClick = {()=>this.setState({flag_eventCreateLocation: true})}
                                    style={{top:'0px'}}
                                    >
                                Créer Lieu
                            </Button>
                        </FormControl>
                    </Stack>
                    </Container>
                    
                    </Flex>
                </Container>
                
                {this.state.flag_loadingLocation ? <Spinner/>:

                    this.state.selectedVenueID !== null ? 
                    <Container until="xl" className="container-left"  style={{paddingLeft:"0px", marginRight:"unset"}}>
                        <Flex wrap={true} direction="row" >
                            {/*Adresse*/}
                            <FormControl
                                label="Adresse"
                                style={{paddingLeft:30}}
                            >
                                <div>{this.state.selectedVenue.address}</div>
                                
                            </FormControl>

                            {/*ZIP*/}
                            <FormControl
                                label="Code postal"
                                style={{paddingLeft:30}}
                            >
                                <div>{this.state.selectedVenue.zip}</div>
                                
                            </FormControl>

                            {/*CITY*/}
                            <FormControl
                                label="Ville"
                                style={{paddingLeft:30}}
                            >
                                <div>{this.state.selectedVenue.city}</div>
                                
                            </FormControl>

                            <FormControl
                                label="Action"
                                style={{paddingLeft:30}}
                            >
                                <div> <Link onClick={this.onUpdateLocation} style={{paddingLeft:0}}>Modifier</Link>
                                    <Link onClick={this.onDeleteLocation}>Supprimer</Link>  
                                </div>
                                
                            </FormControl>
                        </Flex>
                    </Container>
                :null}
                
                {/*SUBMIT*/}
                <Container until="sm" className="container-left" style={{paddingLeft:"0px"}}>
                <Flex wrap={true} direction="row" >
                    <FormControl
                        className="button-controlForm"
                    >
                        <Button variant="primary" 
                                        onClick = {this.onUpdateEventSubmit}
                                        disabled = {!this.titleValid() 
                                            || !this.allDayValid()
                                            || !this.descriptionValid()
                                            }
                                        style={{
                                            width: "100%"
                                            }}>
                                        MODIFIER EVENEMENT
                        </Button>
                    </FormControl>
                </Flex>
                </Container>

            </div>
        );
    }

    /**
     * FUNCTIONS
     */

     getVenues=async()=>{
        //retrieve locations list
        let venues = await this.WPCalendarEvent.getCalendarVenues();

        //Authenticate error ?
        if(GlobalWPUser.user_error.status){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: GlobalWPUser.user_error.status + ": "+GlobalWPUser.user_error.code,
                notifDescription: GlobalWPUser.user_error.message
              });

        }

        //API CALL Error ?
        else if (venues === undefined || venues === null){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la récupération des lieux",
                notifDescription: null
              });

        }else if(this.WPCalendarEvent.WPCalendarError.status !== null) {
            //API call failed

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la récupération des lieux",
                notifDescription: this.WPCalendarEvent.WPCalendarError.status+": "+this.WPCalendarEvent.WPCalendarError.message
              });
        }
        else{
            //ALL is OK
            this.setState({venues:venues});
        }
     }

    /**
     * EVENTS
     */

    onChangeLocation = (selectedItem) => {
        //debugger;
        if(selectedItem.length === 0 || selectedItem.currentTarget.value === ''){
            this.setState({selectedVenue:{}});
            this.setState({selectedVenueID:null});
        }else{
            //let id = selectedItem[0].id;
            let id = selectedItem.currentTarget.value;
            this.setState({selectedVenue:this.WPCalendarEvent.getCalendarVenuByID(parseInt(id))});
            this.setState({selectedVenueID:id});
        }
        

    }

    //Vérification Title
    titleValid = () => {
        return this.state.form.title !== undefined && this.state.form.title.length > 0;
    };


    //Title Input Change handler
    onChangeTitle = (event) => {
         
        let formData = this.state.form;
        formData.title = event.target.value;
        
        this.setState({form:formData});
         
    }


    //Start Date Input Change handler
    onChangeStartDate = (date) => {
        //debugger; 
        let formData = this.state.form;
        formData.start_date = date;
        
        this.setState({form:formData});
         
    }



    //End Date Input Change handler
    onChangeEndDate = (date) => {
         
        let formData = this.state.form;
        formData.end_date = date;
        
        this.setState({form:formData});
         
    }



    //Publish Date Input Change handler
    onChangeDate = (date) => {
         
        let formData = this.state.form;
        formData.date = date;
        
        this.setState({form:formData});
         
    }

    //Vérification All Day Event
    allDayValid = () => {
        return this.state.form.allDay !== undefined && this.state.form.allDay.length > 0;
    };


    //All Day Event Input Change handler
    onChangeAllDay = (event) => {
         
        let formData = this.state.form;
        
        formData.allDay = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Vérification Description
    descriptionValid = () => {
        return this.state.form.description !== undefined && this.state.form.description.length > 0;
    };


    //Description Input Change handler
    onChangeDescription = (event) => {
         
        let formData = this.state.form;
        formData.description = event.target.value;
        
        this.setState({form:formData});
         
    }

    
    //Submit Event creation
    onUpdateEventSubmit = async (event) =>  {
        
        let formData = this.state.form;
        let venueID = this.state.selectedVenueID;
        
        if(formData.allDay === "true"){
            formData.allDay = true;
        }else{
            formData.allDay = false;
        }



        let response = await this.WPCalendarEvent.updateCalendarEvent(
                                                                    formData.id,
                                                                    formData.title,
                                                                    formData.start_date,
                                                                    formData.end_date,
                                                                    formData.date,
                                                                    formData.description,
                                                                    formData.allDay,
                                                                    venueID
                                                                    );
        //Authenticate error ?
        if(GlobalWPUser.user_error.status){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: GlobalWPUser.user_error.status + ": "+GlobalWPUser.user_error.code,
                notifDescription: GlobalWPUser.user_error.message
              });

        }

        //API CALL Error ?
        else if (response === undefined || response === null){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la modification de l'événement",
                notifDescription: null
              });

        }else if(this.WPCalendarEvent.WPCalendarError.status !== null) {
            //API call failed

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la modification de l'événement",
                notifDescription: this.WPCalendarEvent.WPCalendarError.status+": "+this.WPCalendarEvent.WPCalendarError.message
              });

        }
        else{
            //ALL is OK
            eventBus.dispatch("event_editform_close", {   event_editform_close: true });
        }
    }

    //Update Location 
    onUpdateLocation = async (selectedItem) => {
        
        if(selectedItem.length === 0 || selectedItem.currentTarget.value === ''){
            this.setState({selectedVenue:{}});
            this.setState({selectedVenueID:null});
        }else{

            this.setState({flag_eventEditLocation: true});

        }


    }

    //Delete Location Event
    onDeleteLocation = async (event) =>  {

        let venueID = this.state.selectedVenueID;
        
        let response = await this.WPCalendarEvent.deleteCalendarVenue(venueID);

        //Authenticate error ?
        if(GlobalWPUser.user_error.status){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: GlobalWPUser.user_error.status + ": "+GlobalWPUser.user_error.code,
                notifDescription: GlobalWPUser.user_error.message
              });

        }

        //API CALL Error ?
        else if (response === undefined || response === null){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la suppression du lieu",
                notifDescription: null
              });

        }else if(this.WPCalendarEvent.WPCalendarError.status !== null) {
            //API call failed
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la suppression du lieu",
                notifDescription: this.WPCalendarEvent.WPCalendarError.status+": "+this.WPCalendarEvent.WPCalendarError.message
              });
        }
        else{
            //ALL is OK
            this.setNotification(true,{
                notifVariant: "success",
                notifMessage: "Lieu supprimé avec succès",
                notifDescription: null
              });

            
            

            //Reload available Locations
            this.setState({selectedVenue:{}, selectedVenueID: null});

            await this.getVenues();

            //Empty Selected User Item
            //document.getElementById('selectLocation').value = '';
        }

    }
    
    
    decodeHtmlCharCodes(str) { 
        
        return str.replace(/(&(rsquo);)/gi, "'");
      }


}
export default EventEditForm;

